import request from './base/api';
import store from '@/store';

//取得會員訂單
export function fetchMemberOrders({ search_name, owe_money, page }, cb, errCb) {
  let member_id = store.getters['member/memberId'];

  const config = {
    params: {
      page,
      member_id,
      search_name,
      owe_money
    }
  };

  return request({
    url: 'member/orders',
    method: 'get',
    cb,
    errCb,
    config
  });
}

//計算訂單金額
export function calcOrderPrice(
  {
    programs,
    products,
    coupons,
    subtotal_discount_type,
    subtotal_discount_number,
    uniqueId,
    additionalPrice,
    discount,
    member_id
  },
  cb,
  errCb
) {
  const config = {
    data: {
      programs,
      products,
      coupons,
      subtotal_discount_type,
      subtotal_discount_number,
      additionalPrice,
      discount,
      member_id
    }
  };

  return request({
    url: `order/calc-order-price#${uniqueId}`,
    method: 'post',
    cb,
    errCb,
    config
  });
}

//建立訂單
export function createOrder(order, cb, errCb) {
  const config = {
    data: order
  };

  return request({
    url: 'order/store',
    method: 'post',
    cb,
    errCb,
    config
  });
}

//訂單付款資訊
export function getOrderPayment(orderId, cb, errCb) {
  const config = {
    params: { order_id: orderId }
  };

  return request({
    url: 'order/get-order-payment',
    method: 'get',
    cb,
    errCb,
    config
  });
}

//二次收尾款
export function receiveOrderPayment({ order_id, payments }, cb, errCb) {
  const config = {
    data: { order_id, payments }
  };

  return request({
    url: 'order/receive-order-payment',
    method: 'post',
    cb,
    errCb,
    config
  });
}

//開立發票
export function issueInvoice(
  { order_id, category, email, carrier_type, carrier_num, tax_id },
  cb,
  errCb
) {
  const config = {
    data: { order_id, category, email, carrier_type, carrier_num, tax_id }
  };

  return request({
    url: 'order/issue-invoice',
    method: 'post',
    cb,
    errCb,
    config
  });
}

// 取得列印明細網址
export function issueDetail({ order_id }, cb, errCb) {
  const config = {
    data: { order_id }
  };

  return request({
    url: 'order/issue-detail',
    method: 'post',
    cb,
    errCb,
    config
  });
}

// 回傳格式
// id: 折扣活動ID
// type: 折扣活動類型:8=固定折扣% 9=固定折扣金額 10=贈品 11=加價購
// name: 折扣活動名稱
// title: 折扣活動金額名義(ex:   加購價、贈品、滿 Ｏ件，Ｏ折等等)
// price: 若type 為8 or 9 則該值為折扣金額，其餘類型為0
// freebie_limit: 若type 為10，可選擇贈品數量、其餘狀況為0
export function getDiscount(
  { branch_id, products, uniqueId, member_id },
  cb,
  errCb
) {
  const config = {
    data: {
      branch_id,
      products,
      member_id
    }
  };

  return request({
    url: `order/get-discount#${uniqueId}`,
    method: 'post',
    cb,
    errCb,
    config
  });
}

export function getFreebieOrAdditionalPrice(id, cb, errCb) {
  const config = {
    params: {
      id
    }
  };

  return request({
    url: 'order/get-freebie-or-additional-price',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export default {
  fetchMemberOrders,
  calcOrderPrice,
  issueDetail,
  getDiscount,
  getFreebieOrAdditionalPrice
};
